import useModal from "@rf/base/modal/useModal";
import readXlsxFile from "read-excel-file";
import clearExcelData from "./helps/clearExcelData";
import { determinePropertyIdentifier } from "./helps/identifierTypeTemplate";
import { useEffect, useRef } from "react";
import useAlert from "@rf-hooks/useAlert";
import { ETypeTemplate } from "./models/upTemplate.model";
import {
  coverHouseTemplate,
  coverIndustrialTemplate,
  coverLandTemplate,
  coverApartmentTemplate,
  coverComercialSiteTemplate
} from "./helps/converTemplates";
import { processAllSets } from "./helps/getBuildingGroups";
import HCheckArray from "@rf-helper/check-have-value";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { getExcelFilesPath } from "@/src-refactor/modules/shared/model/const/excel-files-path.const";
import toast from "react-hot-toast";

const useUpTemplateBuilding = (typeProperties: I_GENERIC_ITEMS[]) => {
  const inputContent = useRef<HTMLInputElement>(null);
  const { alert } = useAlert();
  const {} = useModal();

  const processFile = async (file: File) => {
    const dataRowsDirty = await readXlsxFile(file, {});
    const headerRowIndex = dataRowsDirty.findIndex(
      row => row.includes("Nombre de conjunto") && row.includes("Fecha de entrega")
    );
    const relevantData = dataRowsDirty.slice(headerRowIndex);
    const { headerRow, dataRows, cleanData } = clearExcelData(relevantData);
    const type = determinePropertyIdentifier(headerRow);

    if (type === "invalid") {
      alert({
        title: "Atención",
        message: "La plantilla no es válida. Verifica las columnas correspondientes.",
        type: "error",
        color: "error.main",
        confirmBtnMessage: "Ok"
      });
      console.log(new Error("Invalid template"));
      return;
    }
    const buildings = processAllSets(cleanData);
    console.log(buildings);
    if (type === ETypeTemplate.land) {
      return coverLandTemplate(buildings);
    } else if (type === ETypeTemplate.industrialSite) {
      return coverIndustrialTemplate(buildings);
    } else if (type === ETypeTemplate.house) {
      return coverHouseTemplate(buildings);
    } else if (type === ETypeTemplate.comercialLocals) {
      return coverComercialSiteTemplate(buildings);
    } else if (type === ETypeTemplate.apartment) {
      return coverApartmentTemplate(buildings);
    } else {
      console.log("Invalid template");
      return;
    }
  };

  const clickLoadTemplate = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      const input = document.getElementById("input-excel") as HTMLInputElement;

      if (!input) {
        reject(new Error("Input element not found"));
        return;
      }

      input.onchange = async (e: Event) => {
        const target = e.target as HTMLInputElement;
        const file = target.files?.[0];

        if (!file) {
          reject(new Error("No file selected"));
          return;
        }

        try {
          const data = await processFile(file);
          console.log(data);
          input.value = "";
          resolve(data);
        } catch (error) {
          reject(error);
        }
      };

      input.click();
    });
  };

  const downloadExcelFiles = () => {
    if (HCheckArray(typeProperties)) {
      const idType = typeProperties[0].id as any;
      const link = document.createElement("a");
      const { name, path } = getExcelFilesPath(idType);
      link.href = path;
      link.download = name;
      link.className = "remo";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      toast.error("Se requiere seleccionar typo de proyecto");
    }
  };

  useEffect(() => {
    const inputTag = document.createElement("input");
    inputTag.type = "file";
    inputTag.accept = ".xlsx";
    inputTag.style.display = "none";
    inputTag.id = "input-excel";

    // append input to body
    document.body.appendChild(inputTag);

    return () => {
      const input = document.getElementById("input-excel");
      if (input) {
        input.remove();
      }
    };
  }, []);

  return {
    clickLoadTemplate,
    downloadExcelFiles
  };
};

export default useUpTemplateBuilding;
